import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UtilsModule } from '@tablesready/common-ui';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { DateFormatPipe } from '@tablesready/frontend-pipes';

import { WaitlistQuotedTimeComponent } from './waitlist-quoted-time.component';

@NgModule({
  declarations: [WaitlistQuotedTimeComponent],
  exports: [WaitlistQuotedTimeComponent],
  imports: [
    CommonModule,
    FrontendIconsModule,
    UtilsModule,
    DateFormatPipe,
  ],
})
export class WaitlistQuotedTimeModule {}
